/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_7_ClientInputs */

const et_portfolio_project_7_client = /** @type {(inputs: Portfolio_Project_7_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biolife (Tervise- ja heaolutooted)`)
};

const en_portfolio_project_7_client = /** @type {(inputs: Portfolio_Project_7_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biolife (Health and wellness products)`)
};

/**
* | output |
* | --- |
* | "Biolife (Health and wellness products)" |
*
* @param {Portfolio_Project_7_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_7_client = /** @type {((inputs?: Portfolio_Project_7_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_7_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_7_client(inputs)
	return en_portfolio_project_7_client(inputs)
});